export const isSSR = () => typeof window === 'undefined'

export const onClientSide = (fn) => !isSSR() && fn()
